import { primaryMain, secondaryMain, white } from 'themes/colors';

export default {
  message: {
    fontSize: '22px',
    lineHeight: '28px',
    fontWeight: 'normal',
    margin: '50px 0px 0px 200px',
    '@media screen and (max-width: 600px)': {
      margin: '24px 16px',
    },
  },
  listings: {
    padding: '0px 10px',
  },
  sidenav: {
    gridColumnStart: 1,
    gridColumnEnd: 2,
    width: '0px',
    overflowX: 'hidden',
    transition: 'width 0.5s linear',
    '@media screen and (max-width: 600px)': {
      width: '0 !important',
    },
  },
  sideNavContent: {
    display: 'grid',
    gridColumnStart: 1,
    gridColumnEnd: 2,
    gridRowStart: 1,
    gridRowEnd: 2,
    width: '400px',
    height: '1215px',
    opacity: 0,
    visibility: 'hidden',
    alignContent: 'start',
    gridTemplateRows: 'fit-content(0px)',
    padding: '30px 0px 0px 15px',
    fontSize: '16px',
    backgroundColor: 'white',
    transition: 'opacity 0.5s linear',
    // TODO: [DRY] use a color palette constant instead of string literal here.
    // See `frontend-shared/theme/colors.js`
    boxShadow: `0 1px 2px rgba(0,0,0,0.07), 
                0 2px 4px rgba(0,0,0,0.07), 
                0 4px 8px rgba(0,0,0,0.07), 
                0 8px 16px rgba(0,0,0,0.07),
                0 16px 32px rgba(0,0,0,0.07), 
                0 32px 64px rgba(0,0,0,0.07)`,
    '@media screen and (max-width: 600px)': {
      position: 'fixed',
      top: 56,
      left: 0,
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      maxHeight: 'calc(100vh - 56px)',
      overflowY: 'auto',
      zIndex: '6 !important',
      backgroundColor: 'white',
    },
  },
  statusFilter: {
    display: 'grid',
    gridAutoFlow: 'row',
    padding: '0px 0px 0px 25px',
    width: '100%',
  },
  labelAndChips: {
    gridColumnStart: 1,
    gridColumnEnd: 2,
    gridRowStart: 1,
    gridRowEnd: 2,
    justifySelf: 'start',
    padding: '40px 10px 40px 20px',
    transition: 'margin 0.5s linear',
    zIndex: 4,
    maxHeight: '100px',
    '@media screen and (max-width: 600px)': {
      maxHeight: 'none',
      padding: '16px 12px',
      marginLeft: '0 !important',
    },
  },
  listingsAndMap: {
    display: 'grid',
    gridColumnStart: 1,
    gridColumnEnd: 2,
    gridRowStart: 1,
    gridRowEnd: 2,
    gridTemplateColumns: 'fit-content(0px) 1fr',
    margin: '105px 0px 0px 10px',
    zIndex: 2,
    '@media screen and (max-width: 600px)': {
      gridColumn: '1 / -1',
      gridRowStart: 2,
      gridRowEnd: 3,
      gridTemplateColumns: 'minmax(0, 1fr)',
      margin: '0',
    },
  },
  listingsColumn: {
    minWidth: 0,
    '@media screen and (max-width: 600px)': {
      gridColumn: '1 / -1 !important',
    },
  },
  filterButton: {
    gridColumnStart: 1,
    gridColumnEnd: 2,
    gridRowStart: 1,
    gridRowEnd: 2,
    maxHeight: '75px',
    justifySelf: 'start',
    position: 'relative',
    right: '5px',
    top: '15px',
    zIndex: 2,
    transition: 'opacity 0.5s linear',
  },
  filterButtonStyle: {
    minWidth: '125px',
    color: white,
    backgroundColor: primaryMain,
    '&:hover': {
      backgroundColor: secondaryMain,
      cursor: 'hand',
    },
  },
  checkbox: {
    color: primaryMain,
    '&.Mui-checked': {
      color: primaryMain,
    },
  },
};
